import React from 'react';

// import { Button } from 'flowbite-react';
import BioLabel from './Label';
import ButtonSansStyle from './ButtonSansStyles';

interface Props {
    readonly labelText: string;
    readonly subHeader: string;
    readonly fileName?: string;
    readonly onClickAdd: (type) => void;
    readonly onClickEdit: (type) => void;
    readonly onClickRemove: (type) => void;
    readonly openModal?: (type) => void;
}

function FilePanel({
    labelText,
    subHeader,
    fileName = '',
    onClickAdd,
    onClickEdit,
    onClickRemove,
    openModal = (_) => {},
}: Props) {
    return (
        <div>
            {
                !fileName
                    ? (
                        <div className="flex flex-col gap-4 sm:flex-row justify-between items-start sm:items-center bg-gray-100 border border-gray-200 rounded-md drop-shadow-sm min-h-[74px] w-full p-4">
                            <div className="flex">
                                <BioLabel
                                    header={labelText}
                                    subHeader={subHeader}
                                    openModal={openModal}
                                />
                            </div>
                            <button type="button" onClick={onClickAdd} className="h-[34px] w-[108px] flex shrink-0 gap-2 justify-center items-center text-gray-900 bg-cirrusWhite border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-3 py-2 dark:bg-gray-800 dark:text-cirrusWhite dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700">
                                <img src="/images/bio/file-outline.png" alt="file" className="h-3 w-3" />
                                <span className="text-xs min-w-[70px]">Select a file</span>
                            </button>
                        </div>
                    )
                    : (
                        <div className="flex justify-between gap-4 items-center bg-gray-100 border border-gray-200 rounded-md drop-shadow-sm min-h-[74px] w-full p-4">
                            <div className="flex items-center gap-2 text-noonBlue font-instrument-sans text-base font-normal w-5/6 sm:w-full break-all">
                                <img src="/images/bio/file-pdf-outline.png" alt="pdf" className="h-3 w-3 " />
                                <div className="break-normal overflow-hidden whitespace-nowrap text-ellipsis">
                                    {' '}
                                    {fileName}
                                    {' '}
                                </div>
                            </div>
                            <div className="flex items-center gap-2 min-w-[32px]">
                                <ButtonSansStyle onClick={onClickEdit}>
                                    <img src="/images/bio/edit-outline.png" alt="edit" className="h-3 w-3 hover:cursor-pointer" />
                                </ButtonSansStyle>
                                <ButtonSansStyle onClick={onClickRemove}>
                                    <img src="/images/bio/trash-outline.png" alt="remove" className="h-3 w-3 hover:cursor-pointer" />
                                </ButtonSansStyle>
                            </div>
                        </div>
                    )
            }
        </div>
    );
}

export default FilePanel;
